export default "__VITE_ASSET__BwDQQlb5__"